export const getBackendUrl = () => {
  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    return `http://${window.location.hostname}:5000`;
  }
  // In Production (Traefik), we use relative paths so requests go to /api/...
  // VITE_BACKEND_URL should be empty or "/" if proxied.
  // "http://backend:5000" is internal Docker DNS, browsers cannot resolve it.
  return import.meta.env.VITE_BACKEND_URL || "";
};

const config = {
  API_URL: getBackendUrl()
};

export default config;
